import request from '../request'

export const userApi = {
  // 准备登录（存储邀请码）
  prepareLogin(inviteCode) {
    return request.post('/v1/auth/prepare-login', { inviteCode })
  },

  // 获取用户信息
  getProfile() {
    return request.get('/v1/public/userinfo')
  },
  // 用户退出
  logout() {
    return request.post('/logout')
  },

  // 获取当前用户的 API Key
  getCurrentApikey() {
    return request.get('/v1/apikey/current')
  },

  // 生成 API Key
  generateApikey() {
    return request.post('/v1/apikey/generate', null, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  },

  // 检查 API Key 可用性
  checkApikey(apiKey) {
    const params = new URLSearchParams()
    params.append('apiKey', apiKey)
    return request.post('/v1/apikey/check', params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  }
}
